module.exports = __webpack_public_path__ + "img/upload_logo.fa5c0f58.svg";